import * as React from "react";
import { useDispatch } from "react-redux";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import CustomSwitch from "../Switch";
import { updateStatus } from "../../http/auth";
import { showToast } from "../../store/slices/common";
import TablePagination from "../../components/Table/TablePagination";

const TableComponent = ({
  sort,
  smScreen,
  sortOrder,
  columns,
  rows,
  page,
  nextId,
  rowsPerPage,
  setSortOrder,
  setLoading,
  onPrevClick,
  onNextClick,
  dataUpdateStatusChange,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const label = { inputProps: { "aria-label": "Switch demo" } };

  const onChangeStatus = async (event, id, index) => {
    try {
      setLoading(true);
      const res = await updateStatus(id);
      if (res.status === 200) {
        dataUpdateStatusChange(id, event.target.checked);
        setLoading(false);
        dispatch(
          showToast({ msg: "Status updated successfully", color: "success" })
        );
      }
    } catch (error) {
      setLoading(false);
      dispatch(
        showToast({
          msg: error?.response?.data?.message,
          color: "error",
        })
      );
    }
  };

  return (
    <div style={{ height: "calc(100% - 61px)" }}>
      <TableContainer
        sx={{
          width: "calc(100% - 2px)",
          borderRadius: "10px",
          marginTop: "12px",
          maxHeight: "calc(100% - 68px)",
          border: "1px solid rgba(224, 224, 224, 1)",
          overflowY: "auto",
        }}
      >
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column, index) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                  sx={{
                    color: "#323C47",
                    fontSize: "16px",
                    fontWeight: "700",
                  }}
                  sortDirection={sortOrder}
                >
                  {column.label}
                  {index === 1 && sort && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: smScreen ? "31px" : "16px",
                        left: "60px",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        setSortOrder(sortOrder !== "asc" ? "asc" : "desc")
                      }
                    >
                      {sortOrder === "" && (
                        <UnfoldMoreIcon
                          fontSize="small"
                          sx={{ marginTop: "2px" }}
                        />
                      )}
                      {sortOrder === "asc" && <ExpandMoreIcon />}
                      {sortOrder === "desc" && <ExpandLessIcon />}
                    </Box>
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                    {columns.map((column, ind) => {
                      const value = row[column.id];
                      return (
                        <TableCell
                          key={column.id}
                          align={column.align}
                          sx={{
                            color:
                              value === "block"
                                ? "green"
                                : value === "unblock"
                                  ? "red"
                                  : "#323C47",
                            fontSize: "16px",
                            height: "24px",
                            padding:
                              ind === columns.length - 1
                                ? "11px 16px 11px 28px"
                                : "11px 16px",
                          }}
                        >

                          {column.format && typeof value === "number" ? (
                            column.format(value)
                          ) : ["block", "unblock"].includes(value) ? (
                            <CustomSwitch
                              {...label}
                              checked={value === "block"}
                              onChange={(e) => onChangeStatus(e, row.id)}
                            />
                          ) : (
                            value
                          )}

                          {/* action buttons */}
                          {value === "" && (
                            <VisibilityOutlinedIcon
                              fontSize="medium"
                              onClick={() =>
                                navigate(
                                  `${window.location.pathname}?id=${row.id}`,
                                  { replace: true, state: { row } }
                                )
                              }
                              sx={{
                                cursor: "pointer",
                                height: "24px",
                                width: "24px",
                              }}
                            />
                          )}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      {/* <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        onClick={(value) => console.log("clicked", value)}
      /> */}
      <TablePagination
        page={page}
        count={rows?.length}
        nextId={nextId}
        onNextClick={onNextClick}
        onPrevClick={onPrevClick}
      />
    </div>
  );
};

export default TableComponent;
